

const Spinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div
        className="spinner-border spinner-border-lg"
        role="status"
        style={{ width: '3rem', height: '3rem', color: "#1f508d" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default Spinner;